
import { defineComponent } from "vue";
import "vue-datepicker-next/index.css";
import "vue-datepicker-next/locale/ru";
import { mapActions, mapGetters } from "vuex";
import FilterCompany from "../filters/FilterCompany.vue";
import FilterEndDate from "../filters/FilterEndDate.vue";
import FilterPrice from "../filters/FilterPrice.vue";
import FilterRegion from "../filters/FilterRegion.vue";
import FilterSource from "../filters/FilterSource.vue";
import FilterStartDate from "../filters/FilterStartDate.vue";
import FilterType from "../filters/FilterType.vue";
import FilterCategory from "../filters/FilterCategory.vue";
import FilterStatus from "../filters/FilterStatus.vue";
import ButtonSaveTemplate from "./ButtonSaveTemplate.vue";
import ButtonApplyFilters from "./ButtonApplyFilters.vue";
import ButtonResetFilters from "./ButtonResetFilters.vue";
import ButtonDeleteTemplate from "./ButtonDeleteTemplate.vue";

import "vue-select/dist/vue-select.css";
import { EventType, trackEvent } from "@/helpers/AmplitudeHelper";
import { isNonSubscribableFilter } from "@/helpers/SearchHelper";

export default defineComponent({
  name: "SidebarSearch",
  components: {
    ButtonSaveTemplate,
    FilterRegion,
    FilterType,
    FilterCategory,
    FilterPrice,
    FilterStartDate,
    FilterEndDate,
    FilterCompany,
    FilterSource,
    FilterStatus,
    ButtonApplyFilters,
    ButtonResetFilters,
    ButtonDeleteTemplate,
  },
  computed: {
    ...mapGetters(["filterOptions", "filters", "query", "page", "templateExists", "filterUpdated", "canSubscribe", "company", "getLanguage"]),
    currentRoute() {
      return this.$route.name as string
    },
    showApplyButton() {
      return (Object.keys(this.$store.getters.filters).length === 0 && this.$store.getters.query === "") || 
        isNonSubscribableFilter(this.$store.getters.filters) ||
        (!this.$store.getters.filterUpdated && !this.$store.getters.canSubscribe) || 
        (this.$store.getters.filterUpdated)
    },
    showSubscribeButton() {
      const routeNames = ['tenderSerp', 'company', 'sourceSerp', 'typeSerp', 'regionSerp', 'categorySerp'];
      const filters = this.$store.getters.filters;

      return (
        routeNames.includes(this.$route.name as string) &&
        !this.$store.getters.templateExists &&
        !this.$store.getters.filterUpdated &&
        !(Object.keys(filters).length === 0 && this.$store.getters.query === "") &&
        !isNonSubscribableFilter(filters) &&
        this.$store.getters.canSubscribe
      );
    },
    showUnsubscribeButton() {
      const routeNames = ['tenderSerp', 'company', 'sourceSerp', 'typeSerp', 'regionSerp', 'categorySerp'];
      const filters = this.$store.getters.filters;

      return (
        routeNames.includes(this.$route.name as string) && 
        this.$store.getters.templateExists && 
        (!this.$store.getters.filterUpdated) && 
        !(Object.keys(filters).length === 0 && this.$store.getters.query === "") && 
        !isNonSubscribableFilter(filters) &&
        this.$store.getters.canSubscribe
      )
    },
    language() {
      return this.$store.getters.getLanguage;
    },
  },
  methods: {
    ...mapActions(["toggleAuthModal", "getFilterOptions", "saveTemplate", "deleteTemplate"]),
    resetFilters() {
      let resetFiltersPayload = {}
      switch (this.$route.name) {
        case 'company':
          resetFiltersPayload = { keepFilter: { filterType: 'company' }}
          break
        case 'sourceSerp':
          resetFiltersPayload = { keepFilter: { filterType: 'source' }}
          break
        case 'typeSerp':
          resetFiltersPayload = { keepFilter: { filterType: 'type' }}
          break
        case 'regionSerp':
          resetFiltersPayload = { keepFilter: { filterType: 'region' }}
          break
        case 'categorySerp':
          resetFiltersPayload = { keepFilter: { filterType: 'category' }}
          break
      }
      this.$store.dispatch('resetFilters', resetFiltersPayload)
      trackEvent(EventType.filters_reset)
    },
    applyFilters() {
      this.$store.dispatch('applyFilters')
    }
  },
  async created() {
    const lang = localStorage.getItem('language')
    await this.getFilterOptions({ lang: lang });
  },
  watch: {
    language: {
      async handler(newValue) {
        await this.getFilterOptions({ lang: newValue })
      }
    }
  },
  async unmounted() {
    this.$store.dispatch('resetFilters', { shouldApplyFilter: false })
  }
});
